export default "__VITE_ASSET__BFo5ZGv7__"